'use client';import React from 'react';
import PageBanner from '../components/PageBanner';
import bannerImage from '../assets/legal/terms_banner.webp';

const TermsOfUse = () => {
    return (
        <>
            <PageBanner
                title="Terms of Use"
                description="Please read these terms carefully before using our platform. They outline the rules and regulations for the use of Exibell's Website."
                bgColor="#EEF2FF"
                blobColors={["#818CF8", "#C084FC", "#60A5FA"]}
            />

            <div className="container container-prose py-20">
                <div className="max-w-3xl mx-auto">
                    <p className="text-md text-gray-500 mb-10">Last updated: {new Date().toLocaleDateString()}</p>

                    <div className="space-y-12">
                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">1. Acceptance of Terms</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                By accessing and using Exibell, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">2. Use License</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                Permission is granted to temporarily download one copy of the materials (information or software) on Exibell's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-display-xs font-semibold mb-4 text-gray-900">3. Disclaimer</h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                The materials on Exibell's website are provided on an 'as is' basis. Exibell makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability.
                            </p>
                        </section>
                    </div>

                    <div className="mt-16 pt-8 border-t border-gray-100">
                        <p className="text-gray-500 italic">This is a summary of our full Terms of Use. For detailed information, please contact our legal team.</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TermsOfUse;
